module.exports = __webpack_public_path__ + "static/media/ghostie.cb373311.svg";